import type { RaceEvent } from '@/api/events';

/// #936 — eventos que o índice de Resultados oferece. Rascunho fica de fora:
/// ainda não tem dia publicado, e a página de resultados abriria vazia.
///
/// Ordem: em andamento primeiro (é o que o organizador apura no dia), depois
/// a ordem do backend. Status desconhecido (backend mais novo que o painel)
/// entra, como na lista de eventos: esconder seria sumir com evento em silêncio.
export function eventsWithResults(events: readonly RaceEvent[]): RaceEvent[] {
  const shown = events.filter((ev) => ev.status !== 'draft');
  const running = shown.filter((ev) => ev.status === 'published' && ev.hasRunningDay);
  const rest = shown.filter((ev) => !(ev.status === 'published' && ev.hasRunningDay));
  return [...running, ...rest];
}
